// extracted by mini-css-extract-plugin
export default {"sensor-container":"RoomSensor_sensor-container__xmWfI","btn-deactivate":"RoomSensor_btn-deactivate__XxDHV","active":"RoomSensor_active__GaVPh"};